'use strict';exports.__esModule = true;var _ipRegex = require('../../utils/ipRegex.min');var _ipRegex2 = _interopRequireDefault(_ipRegex);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var exactIpRegEx = (0, _ipRegex2.default)({ exact: true });

var stripUrlPort = function stripUrlPort(url) {
  var portBeginning = url.indexOf(':');
  if (portBeginning !== -1) {
    return url.substr(0, portBeginning);
  }

  return url;
};

var isIp = function isIp(ip) {var stripPort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;return exactIpRegEx.test(stripPort ? stripUrlPort(ip) : ip);};exports.default =

isIp;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/middleware/utils/is-ip.js
// module id = 3077
// module chunks = 0